/* eslint-disable */

import axios from "axios";
import {make} from "vuex-pathify";

const url = require("../../client_config/config").url;

const state = {
  allUsers: [],
  user: {},
  userCompany: "",
};

const getters = {
  getAllUsers: (state) => state.allUsers,
  user: (state) => state.user,
  userCompany: (state) => state.userCompany,
};

const actions = {
  async fetchAllUsers({commit}) {
    try {
      const response = await axios.get(`${url}/users/`);
      commit("SET_ALL_USER", response.data.users);
      return response.data.users;
    } catch (error) {
      console.error(e.response);
      return error.response;
    }
  },

  async getUser({commit}) {
    try {
      let userID = localStorage.getItem("userID")
      const response = await axios.get(`${url}/users/${userID}`);
      commit("SET_USER", response.data.user);
      commit("SET_USER_ROLE", response.data.user.Role);
      commit("SET_USER_COMPANY", response.data.user.Company?.[0]?.Name || " ");
      return response;
    } catch (error) {
      console.error(e.response);
      return error.response;
    }
  },


  async updatedVerificationStatus({commit}, data) {
    try {
      const response = await axios.patch(`${url}/users/verification/`, data);
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async downloadCSV({commit}, state) {
    try {
      const response = await axios.get(`${url}/users/generate/csv/${state}`);
      return response.data;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },

};

const mutations = {
  ...make.mutations(state),
  SET_ALL_USER(state, data) {
    state.allUsers = data;
  },

  SET_USER(state, data) {
    state.user = data;
  },

  SET_USER_ROLE(state, role) {
    state.userRole = role;
  },

  SET_USER_COMPANY(state, companyName) {
    state.userCompany = companyName; // Update userCompany
  },

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
